import { DsCompany } from './ds-company';
import { DsCompanyGroup } from './ds-company-group';

export class DsCompanyWithChildren extends DsCompany {
  /**
   *
   */
  public children: DsCompanyGroup[] = [];

  /**
   * Creates an instance of DsCompanyWithChildren.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    super(jsonData);
    this.children = jsonData.children || this.children;
  }
}
